<template>
  <div :class="$modal.modalContentContainer">
    <div :class="$modal.modalContent">
      <v-flex>
        <p :class="$modal.modalText">
          Fill in these fields to complete your order as a guest.
          Don’t worry, you can always create an account later.
        </p>
      </v-flex>
      <v-flex :class="$modal.fullWidth">
        <form :class="$style.guestForm">
          <div :class="$style.formFields">
            <div :class="$style.formField">
              <div :class="$modal.modalInput">
                <InputField :class="{[$modal.errorField]: $v.firstName.$error }"
                            v-model="$v.firstName.$model"
                            label="First Name*"/>
                <p v-if="$v.firstName.$error"
                   :class="$modal.errorMessage">
                  First Name is required
                </p>
              </div>
            </div>
            <div :class="$style.formField">
              <div :class="$modal.modalInput">
                <InputField :class="{[$modal.errorField]: $v.lastName.$error }"
                            v-model="$v.lastName.$model"
                            label="Last Name*"/>
                <p v-if="$v.lastName.$error"
                   :class="$modal.errorMessage">
                  Last Name is required
                </p>
              </div>
            </div>
            <div :class="$style.formField">
              <div :class="$modal.modalInput">
                <InputField :class="{[$modal.errorField]: $v.email.$error }"
                            v-model="$v.email.$model"
                            label="Email*"/>
                <p v-if="!$v.email.required && $v.email.$error"
                   :class="$modal.errorMessage">
                  Email is required
                </p>
                <p v-if="!$v.email.email"
                   :class="$modal.errorMessage">
                  Email is not valid
                </p>
              </div>
            </div>
            <div :class="$style.formField">
              <div :class="$modal.modalInput">
                <InputField :class="{[$modal.errorField]: $v.phone.$error }"
                            :return-masked-value="false"
                            v-model="$v.phone.$model"
                            mask="(###) ### - ####"
                            placeholder="(xxx) xxx - xxxx"
                            label="Phone Number*"
                            type="tel"/>
                <p v-if="$v.phone.$error"
                   :class="$modal.errorMessage">
                  Phone number is required
                </p>
              </div>
            </div>
          </div>
          <v-flex :class="$modal.modalButtons">
            <BaseButton :class="$modal.submitBtn"
                        button-style="Main"
                        @click="handleContinue">
              Continue
            </BaseButton>
          </v-flex>
        </form>
      </v-flex>
      <v-flex :class="$modal.signIn">
        <button @click="handleSignIn">Sign in</button>
        or
        <button @click="handleCreateAccount">Create an account</button>
        for better experience
      </v-flex>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { required, email } from 'vuelidate/lib/validators';
import { Action } from 'vuex-class';
import BaseButton from '@/components/BaseButton';
import InputField from '@/components/InputField';
import { AUTH_GUEST_INFO } from '@/apps/auth/store/types';

/**
 * Form to check if phone number exists. On success will store pone data in
 * vuex store for further use.
 *
 * EVENTS:
 *  continue (payload) - When user fill the form and click Continue" button
 *  create-account - When user clicked on "Create an account" button
 *  sign-in - When user clicked on "Sign in" button
 */
@Component({
  name:       'GuestCheckoutModal',
  components: {
    BaseButton,
    InputField,
  },
  validations: {
    firstName: { required },
    lastName:  { required },
    email:     { required, email },
    phone:     { required },
  },
})
export default class GuestCheckoutModal extends Vue {
  firstName = '';
  lastName = '';
  email = '';
  phone = '';

  @Action(AUTH_GUEST_INFO) saveAuthGuestData;

  /**
   * "Continue" button handler
   *
   * Validate form, and if it's OK, emit action with user data to parent.
   */
  handleContinue() {
    this.$v.$touch();

    if (this.$v.$error) {
      return;
    }

    const accountData = {
      firstName: this.firstName,
      lastName:  this.lastName,
      email:     this.email,
      phone:     `+1${this.phone}`,
    };

    // save guest data
    this.saveAuthGuestData({ accountData });
    this.$emit('continue', { userData: accountData });
  }

  /**
   * "signIn" button handler
   */
  handleSignIn() {
    this.$emit('sign-in');
  }

  /**
   * "Create an account" button handler
   */
  handleCreateAccount() {
    this.$emit('create-account');
  }
}
</script>

<style src="@/style/modals.scss" lang="scss" module="$modal"></style>

<style lang="scss" module>
@import "~@/style/variables.scss";

.guestForm {
  padding: 0 20px;
}

.formFields {
  display: flex;
  flex-wrap: wrap;

  .formField {
    width: calc(50% - 40px); /* 50% minus margins */
    margin: 0 20px;
  }
}

.guestForm .formFields .formField label {
  font-family: 'Gotham', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: $label-green;
}

@media screen and (max-width: 767px) {
  .formFields {
    display: flex;
    flex-direction: column;

    .formField {
      width: 100%;
      margin: 0;
    }
  }
}

@media screen and (max-width: 680px) {
  .guestForm {
    padding: 0;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/GuestCheckoutModal.vue